export const BACKORDER_EXPIRY_DAYS = 60;
export const BACKORDER_SEARCH_FILTERS = [
  { value: 'VERDE', text: 'Con existencia 100%' },
  { value: 'AMARILLO', text: 'Con existencias parciales' },
  { value: 'GRIS', text: 'No hay existencias' },
  { value: 'PR', text: 'Programados' },
  { value: 'NEXT_TO_EXPIRE', text: 'Próximos a vencer' },
];
